<template>
    <customModal :containermd="true" @closeModal="closeModal">
        <template #title>
            {{ isEditMode ? 'Update Risk Threshold' : 'Add Risk Threshold' }}
        </template>

        <template #body>
            <div class="modal-scroll-body">
                <div class="row ml-1">
                    <!-- Risk ID -->
                    <!-- <div class="col-md-6 mb-3">
                        <label class="form-label">Risk ID <sup><i class="fa fa-asterisk required"></i></sup></label>
                        <input type="text" class="form-control" v-model="form.RiskID" :disabled="isEditMode"
                        @input="errors.RiskID=''" />
                         <span v-if="errors.RiskID" class="errorClass">
                         {{ errors.RiskID }}
                        </span>
                    </div>   -->

                    <!-- Risk Name -->
                   <div class="col-md-12 mb-3">
                        <label class="form-label">
                            Risk Name <sup><i class="fa fa-asterisk required"></i></sup>
                        </label>

                        <select class="form-control" :value="form.RiskID" @change="onRiskChange">
                            <option value="">Select</option>

                            <option v-for="option in riskOptions" :key="option.value" :value="option.value">
                                {{ option.label }}
                            </option>
                        </select>

                        <span v-if="errors.RiskName" class="errorClass">
                            {{ errors.RiskName }}
                        </span>
                    </div>

                    <!-- Thresholds -->
                    <div class="col-12 mb-2 d-flex justify-content-between align-items-center">
                        <h6 class="mb-0">Thresholds</h6>

                        <div class="position-relative cursor-pointer">
                            <img src="@/assets/img/create.png" width="17" @click="addThreshold"
                                alt="Create Threshold" />
                            <div class="tool-tip">Add Threshold</div>
                        </div>
                    </div>
                    <div class="col-12 mb-1 text-danger" v-if="thresholdError">
                        {{ thresholdError }}
                    </div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Min</th>
                                    <th>Max</th>
                                    <th>Probability</th>
                                    <th>Detectability</th>
                                    <th>Impact</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(t, i) in form.Thresholds" :key="i">
                                    <td><input type="number" class="form-control" v-model.number="t.Min"
                                            @input="thresholdError = ''" /></td>
                                    <td><input type="number" class="form-control" v-model.number="t.Max"
                                            @input="thresholdError = ''" /></td>
                                    <td><input type="number" class="form-control" v-model.number="t.Probability"
                                            @input="thresholdError = ''" /></td>
                                    <td><input type="number" class="form-control" v-model.number="t.Detectibility"
                                            @input="thresholdError = ''" /></td>
                                    <td><input type="number" class="form-control" v-model.number="t.Impact"
                                            @input="thresholdError = ''" /></td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeThreshold(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.Thresholds.length">
                                    <td colspan="6" class="text-center text-muted">No thresholds added</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Unit -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Unit</label>
                        <select class="form-control" v-model="form.Unit">
                            <option value="">Select</option>
                            <option value="Count">Count</option>
                            <option value="Average">Average</option>
                            <option value="Percentage">Percentage</option>
                            <option value="Median">Median</option>
                        </select>
                    </div>

                    <!-- Version -->
                    <div class="col-md-3 mb-3">
                        <label class="form-label">Version</label>
                        <input type="text" class="form-control" v-model="form.Version" />
                    </div>

                    <!-- Is Active -->

                    <div class="col-md-3 mb-3">
                        <label class="form-label"></label>
                        <div class="form-check mt-2">
                            <input type="checkbox" class="form-check-input" id="activeVisitType"
                                v-model="form.IsActive" />
                            <label class="form-check-label ms-2" for="activeVisitType">
                                Active
                            </label>
                        </div>
                    </div>

                    <!-- Risk Level Rules -->
                    <div class="col-12 mb-2 d-flex justify-content-between align-items-center">
                        <h6 class="mb-0">Risk Level Rules</h6>

                        <div class="position-relative cursor-pointer">
                            <img src="@/assets/img/create.png" width="17" alt="Add Risk Level Rule"
                                @click="addRiskRule" />
                            <div class="tool-tip">Add Risk Level Rule</div>
                        </div>
                    </div>
                    <div class="col-12 mb-1 text-danger" v-if="riskRuleError">
                        {{ riskRuleError }}
                    </div>


                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Min Score</th>
                                    <th>Max Score</th>
                                    <th>Label</th>
                                    <th>Color</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>


                            <tbody>
                                <tr v-for="(r, i) in form.RiskLevelRules" :key="i">
                                    <td><input type="number" class="form-control" v-model.number="r.ScoreRange.Min"
                                            @input="riskRuleError = ''" /></td>
                                    <td><input type="number" class="form-control" v-model.number="r.ScoreRange.Max"
                                            @input="riskRuleError = ''" /></td>
                                    <td><input type="text" class="form-control" v-model="r.Label"
                                            @input="riskRuleError = ''" /></td>
                                    <td><select class="form-control " v-model="r.Color" @input="riskRuleError = ''">
                                            <option value="">Select</option>
                                            <option value="#F22613">Red</option>
                                            <option value="#87D37C">Green</option>
                                            <option value="#F5D76E">Orange</option>
                                        </select>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeRiskRule(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.RiskLevelRules.length">
                                    <td colspan="5" class="text-center text-muted">No rules added</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <!-- Critical Data Points -->
                    <div class="col-12 mb-2 d-flex justify-content-between align-items-center">
                        <h6 class="mb-0">Critical Data Points</h6>
                    </div>
                    <div class="row align-items-end mb-3 pr-0">

                        <div class="col-md-5">
                            <label class="form-label">eCRF</label>
                            <select class="form-control cdp-control" v-model="selectedTemplateId"
                                @change="onTemplateChange">
                                <option value="">Select eCRF</option>
                                <option v-for="t in templates" :key="t.templateId" :value="t.templateId">
                                    {{ t.templateName }}
                                </option>
                            </select>
                            <span v-if="cdpError" class="text-danger">
                                {{ cdpError }}
                            </span>
                        </div>

                        <!-- Fields -->
                        <div class="col-md-5">
                            <label class="form-label">Fields</label>
                            <Multiselect class="multiselect-theme" v-model="selectedFields" :options="templateFields"
                                mode="multiple" :close-on-select="false" :clear-on-select="false"
                                :preserve-search="true" :disabled="!templateFields.length" label="label"
                                value-prop="fieldName" track-by="fieldName" :object="true"
                                placeholder="Select fields" />
                        </div>

                        <div class="col-md-2 d-flex justify-content-end align-items-end pr-0">
                            <div class="position-relative cursor-pointer cdp-add-btn">
                                <img src="@/assets/img/create.png" width="18" @click="addCriticalDataPoint"
                                    alt="Add Critical Data Point" />
                                <div class="tool-tip">Add</div>
                            </div>
                        </div>

                    </div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>eCRF</th>
                                    <th>Fields</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, i) in form.CriticalDataPoints" :key="i">
                                    <td>{{ c.templateName }}</td>
                                    <td class="fields-cell">
                                        <span v-if="c.fieldnames === null" class="text-muted">
                                            All fields
                                        </span>

                                        <span v-else class="fields-text">
                                            {{ visibleFields(c).join(', ') }}

                                            <span v-if="c.fieldLabels.length > maxVisibleFields" class="more-less"
                                                @click="toggleFields(c)">
                                                {{ c.showAll ? ' Show less' : ` +${c.fieldLabels.length -
                                                    maxVisibleFields}
                                                more` }}
                                            </span>
                                        </span>
                                    </td>



                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeCriticalDataPoint(i)"></i>
                                    </td>
                                </tr>

                                <tr v-if="!form.CriticalDataPoints.length">
                                    <td colspan="3" class="text-center text-muted">
                                        No Critical Data Points added
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="col-12 text-end mt-3">
                        <button class="save_btn px-4 py-1" @click="save">
                            {{ isEditMode ? "Update" : "Save" }}</button>
                    </div>
                </div>
            </div>
        </template>
    </customModal>
</template>
<script src="./ThresholdAddEditModal.js"></script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.edit-delete {
    color: #a13b7c;
    cursor: pointer;
}

.save_btn {
    background-color: #1ab394;
    border: none;
    color: #fff;
    border-radius: 4px;
}

.multiselect-theme {
    --ms-radius: 0;
    --ms-py: 0.4rem;
    --ms-option-font-size: 0.8rem;
    --ms-option-bg-selected-pointed: rgb(210, 210, 210);
    --ms-option-bg-selected: rgb(210, 210, 210);
    --ms-option-color-selected: #000;
    --ms-option-color-selected-pointed: #000;
}


/* Center add button visually */
.cdp-add-btn {
    margin-bottom: 6px;
}

.more-less {
    color: #4cc2f8;
    cursor: pointer;
    font-size: 0.85rem;
    margin-left: 4px;
    white-space: nowrap;
}

.fields-cell {
    max-width: 350px;
    /* adjust if needed */
    white-space: normal;
    word-break: break-word;
    vertical-align: top;
}

.fields-text {
    display: inline-block;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}

.more-less {
    color: #1ab394;
    cursor: pointer;
    font-size: 0.85rem;
    white-space: nowrap;
    margin-left: 4px;
}

.modal-scroll-body {
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
}
</style>
